import React from 'react';

import { StaticPageLayout } from '../layouts/static-page.layout';

export const PaymentMethods = () => (
  <StaticPageLayout ns="payments" title="payment-methods.title" text="payment-methods.text" />
);

PaymentMethods.getInitialProps = async () => ({
  namespacesRequired: ['common', 'payments'],
});

// noinspection JSUnusedGlobalSymbols
export default PaymentMethods;
